
<template>
    <div class="public_container add_approval_wrap">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"></ReturnNavBar>
        </div>
        <div class="purchase_detail_container mobile_container"  v-loading="loading">
            <CustomFormDetailMobile
                    v-if="dataLoaded"
                    :field_list="formInfoList"
                    :form_detail="purchaseFormData"
                    :pk_id="purchaseId"
                    :is_edit_mode="false"/>
            <div class="custom_title">
                <span>退货记录</span>
            </div>

            <div class="return_record_wrap">
                <div class="return_record_list">
                    <ul>
                        <li v-for="(item,key) in return_record_list" :key="key">
                            <div class="field_list gray">退货{{key+1}}</div>
                            <div class="field_list">审批编号：<span @click="handleClickApprovalDetail(item.approval_id)" v-text="item.approval_id"></span></div>
                            <div class="field_list">发起人：{{item.username}}</div>
                            <div class="field_list">退货时间：{{item.created_at}}</div>
                            <el-table :data="item.return_details" border :span-method="(row,column,rowIndex,columnIndex)=>{return arraySpanMethod({row},item.return_details.length)}"  class=" custom_table">
                                <el-table-column label="退货产品" prop="product_name"  width="194"></el-table-column>
                                <el-table-column align="right" label="退货数量" prop="num"  width="110"></el-table-column>
                                <el-table-column align="right" label="退货总金额（元）" prop="total_price"  width="144">
                                    <template slot-scope="{row,$index}">
                                        <div v-if="$index === 0">
                                            {{item.total_price}}
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="附件" prop="files"  width="144">
                                    <template slot-scope="{row,$index}">
                                        <div v-if="$index === 0">
                                            <ul class="upload_file_list  upload_file_list_detail">
                                                <li class="upload_file_item" v-for="file in item.files" style="padding: 0;background: transparent">
                                                    <div class="file_left_wrap" style="max-width: 100%">
                                                        <img alt="" src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png" class="file_img">
                                                        <div class="file_info_wrap">
                                                            <p class="file_name" v-text="file.file_name"></p>
                                                            <p class="file_size" v-text="file.file_size"></p>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="退货说明" prop="note" width="124"> </el-table-column>
                            </el-table>

                            <div class="show_summary">
                                退货总数量：<span v-text="item.total_num"></span>
                                <span class="line"></span>
                                退货总金额：<span v-text="item.total_price"></span>
<!--                                customForm[field.field_key].reduce((total, item) => total + Number(item.total_price), 0)-->
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

        </div>


    </div>
</template>

<script>
import {getFormFields,PurchaseDetail,PurchaseReturnList} from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import CustomFormDetailMobile from "@/components/mComponents/CustomFormDetailMobile";
export default {
    name: "purchase_detail",
    components: {ReturnNavBar,CustomFormDetailMobile},
    data() {
        return {
            loading:false,
            BtnDisabled: false,
            formInfoList: [],
            purchaseFormData: {},
            dataLoaded:false,
            return_record_list:[],
            purchaseId:0
        };
    },
    created() {
        this.purchaseId = Number(this.$route.query.purchase_id)
        this._getFromFields()
    },
    methods: {
        // 获取字段
        _getFromFields() {
            this.loading = true
            getFormFields({
                field_form: 'purchases'
            }).then(res => {
                if (res.code === 200) {
                    this.formInfoList = res.data
                    this.getPurchaseDetail()
                    this.getPurchaseReturnList()
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        // 获取详情
        getPurchaseDetail(){
            PurchaseDetail({
                purchase_id: this.purchaseId
            }).then(res => {
                if (res.code === 200) {
                    this.purchaseFormData = res.data
                    this.dataLoaded = true
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },

        getPurchaseReturnList(){
            PurchaseReturnList({
                purchase_id: this.purchaseId
            }).then(res => {
                if (res.code === 200) {
                    this.return_record_list = res.data || []
                } else {
                    this.$message.error(res.message)
                }
            }).catch(() => {

            })
        },

        arraySpanMethod(data,length) {
            let { row, column, rowIndex, columnIndex } = data.row
            if (columnIndex === 2 || columnIndex === 3) { // 第三列
                if (rowIndex === 0) {
                    return [length, 1]; // 合并所有行
                } else {
                    return [0, 0]; // 其他行不显示
                }
            }
        },

        // 审批详情
        handleClickApprovalDetail(approval_id) {
            this.$showApprovalDetail({
                approval_id: approval_id,
            }).then((res) => {
                console.log(res);
            });
        },

    },
};
</script>

<style lang="scss" scoped>
    .purchase_detail_container{
        background: #fff;
        padding: 10px 16px;
        box-sizing: border-box;
        .custom_form_detail_wrap{
            height: auto;
        }
        .custom_title{
            width: 100%;
            margin-bottom: 10px;
            box-sizing: border-box;
            span{
                display: block;
                color: rgb(51, 51, 51);
                font-size: 14px;
                line-height: 22px;
                font-weight: 700;
                position: relative;
                padding-left: 12px;
                &:before{
                    width: 4px;
                    height: 22px;
                    left: 0;
                    top: 0;
                    content: " ";
                    position: absolute;
                    background: rgb(41, 144, 255);
                    border-radius: 4px;
                }
            }
        }

        .return_record_wrap{
            width: 100%;
            .return_record_list{
                width: 100%;

                ul{
                    width: 100%;
                    li{
                        width: 100%;
                        padding-top: 10px;
                        border-radius: 6px;
                        background: rgba(249, 249, 249, 1);
                        margin-bottom: 10px;
                        .field_list{
                            margin-bottom: 8px;
                            padding: 0 10px;
                            line-height: 22px;
                            color: rgba(102, 102, 102, 1);
                            font-size: 14px;
                            &.gray{
                                color: rgba(153, 153, 153, 1);
                            }
                            span{
                                color: rgba(41, 144, 240, 1);
                            }
                        }
                    }
                }
                .show_summary{
                    width: 100%;
                    line-height: 38px;
                    padding: 0 12px;
                    box-sizing: border-box;
                    background: rgba(237, 240, 244, 1);
                    box-shadow:inset 0px -1px 0px  rgba(0, 0, 0, 0.08);
                    font-size:14px;
                    color:rgba(153, 153, 153, 1);
                    border-radius: 6px;
                }
            }
        }
    }
</style>
